<template>
    <v-card>
        <v-list-item-group color="primary">
            <v-container>
                <v-row>
                    <v-col
                        v-for="(colSection, si) in globalSection"
                        :key="si"
                        sm="4"
                    >
                        <template v-for="(item, index) in colSection">
                            <div :key="index">
                                <v-list-item
                                    :to="handleCategoryRoute(item)"
                                    :disabled="item.subCategories.length > 0"
                                    exact
                                    @click="$emit('handleCategoryModal')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="primary--text"
                                            >{{
                                                item.title.en
                                            }}</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    dense
                                    v-for="(s, i) in item.subCategories"
                                    :key="i"
                                    :to="handleCategoryRoute(s)"
                                    @click="$emit('handleCategoryModal')"
                                    exact
                                >
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{
                                            s.title.en
                                        }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                            </div>
                        </template>
                    </v-col>
                </v-row>
            </v-container>
        </v-list-item-group>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'CategoryListing',
    data() {
        return {
            categoryModal: false,
            sectionCount: [3, 4, 4, 4],
        }
    },
    props: {},
    computed: {
        ...mapGetters({
            categoryTree: 'common/categoryTree',
        }),
        sectionOne() {
            return this.categoryTree.filter((item) =>
                [
                    'Motor Control',
                    'Disconnect Switches',
                    'Circuit Protection',
                    'Terminal Blocks',
                    'Stack Lights',
                    'Relays & Timers',
                ].includes(item.title.en)
            )
        },
        sectionTwo() {
            return this.categoryTree.filter((item) =>
                [
                    'Push Buttons, Switches & Indicator Lights',
                    'Control Stations',
                ].includes(item.title.en)
            )
        },
        sectionThree() {
            return this.categoryTree.filter((item) =>
                [
                    'Starters',
                    'Wiring Solutions',
                    'Definite Purpose Contactors',
                    'Enclosed Panel Solutions',
                    'Enclosures',
                    'Accessories & Replacement Components',
                ].includes(item.title.en)
            )
        },
        globalSection() {
            return [this.sectionOne, this.sectionTwo, this.sectionThree]
        },
    },
    methods: {
        handleCategoryRoute(category) {
            if (
                category.subCategories === undefined ||
                category.subCategories.length === 0
            ) {
                return {
                    path: '/shop',
                    query: {
                        Categories: category.title.en,
                    },
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.v-list-item {
    min-height: 28px !important;
}
.v-list-item--dense .v-list-item__content {
    padding: 0;
}
.v-application .v-menu__content[role='menu'] .v-list-item:first-child {
    border-top: 0 !important;
}
</style>
